<template>
  <div
    class="sidenav-scroll w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item" v-if="can('view-dashboard')">
        <sidenav-collapse navText="Dashboard" :to="{ name: 'Dashboard' }">
          <template #icon>🏘️</template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="can('visits-index')">
        <sidenav-collapse
          navText="Visits Management"
          :to="{ name: 'Visits Management' }"
        >
          <template #icon>🏥</template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="can('patients-index')">
        <sidenav-collapse navText="Patients" :to="{ name: 'Patients' }">
          <template #icon>👥</template>
        </sidenav-collapse>
      </li>

      <li
        class="nav-item"
        v-if="can('inpatient-index') && package_contains('inpatient')"
      >
        <sidenav-collapse navText="Inpatient" :to="{ name: 'Inpatient List' }">
          <template #icon>🏨</template>
        </sidenav-collapse>
      </li>
      <!-- <li class="nav-item" v-if="can('inpatient-index')">
        <sidenav-collapse navText="Inpatient" :to="{ name: 'InpatientHome' }">
          <template #icon><office /></template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item" v-if="can('dialysis-index')">
        <sidenav-collapse navText="Dialysis" :to="{ name: 'Dialysis' }">
          <template #icon>🧉</template>
        </sidenav-collapse>
      </li> -->
      <!-- <li class="nav-item" v-if="can('special-clinics-index')">
        <sidenav-collapse
          navText="Special Clinics"
          :to="{ name: 'Special Clinics' }"
        >
          <template #icon>🩺</template>
        </sidenav-collapse>
      </li> -->
      <li
        class="nav-item"
        v-if="can('inventory-index') && package_contains('pharmacy')"
      >
        <sidenav-collapse navText="Inventory" :to="{ name: 'Inventory' }">
          <template #icon>🗃️</template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="can('settings-index')">
        <sidenav-collapse navText="Settings" :to="{ name: 'Settings' }">
          <template #icon>🛠️</template>
        </sidenav-collapse>
      </li>
      <li v-if="package_contains('communication')" class="nav-item">
        <sidenav-collapse
          navText="Communications"
          :to="{ name: 'Communications' }"
        >
          <template #icon>💬</template>
        </sidenav-collapse>
      </li>
      <li
        class="nav-item"
        v-if="can('finance-dashboard') && package_contains('finance')"
      >
        <sidenav-collapse
          navText="Finance Dashboard"
          :to="{ name: 'Finance Dashboard' }"
        >
          <template #icon>💰</template>
        </sidenav-collapse>
      </li>
      <!-- <li class="nav-item">
        <sidenav-collapse
          navText="Clinical Reports"
          :to="{ name: 'Clinical Reports' }"
        >
          <template #icon>📑</template>
        </sidenav-collapse>
      </li> -->
      <li class="nav-item" v-if="can('system-users-index')">
        <sidenav-collapse navText="System Users" :to="{ name: 'System Users' }">
          <template #icon><customer-support /></template>
        </sidenav-collapse>
      </li>
      <!--  -->
      <li class="nav-item">
        <sidenav-collapse navText="My Profile" :to="{ name: 'Profile' }">
          <template #icon>𓀀</template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <!-- <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <a
      v-if="can('contact-support')"
      class="btn bg-gradient-success mt-4 w-100"
      href="#"
      type="button"
      >Contact Support</a
    >
  </div> -->

  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <a
      @click="handleSignOut"
      href="#"
      type="button"
      style="padding-top: 2px; bottom: 0"
      class="btn mt-1 w-100"
      ><span style="font-size: 32px">⏻</span> Logout</a
    >
  </div>

  <blocker_modal @close-blocker="unblock" v-if="company_is_inactive" />
</template>

<script>
import can from "../../permissions/permissions";
import SidenavCollapse from "./SidenavCollapse.vue";
// import SidenavCard from "./SidenavCard.vue";
// import Shop from "../../components/Icon/Shop.vue";
// import Office from "../../components/Icon/Office.vue";
// import CreditCard from "../../components/Icon/CreditCard.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import { generalApiRequest } from "../../api/apiIndex";
import blocker_modal from "./blocker_modal.vue";
import package_contains from "../../views/special_clinics/package_contains";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Home Navigation",
      controls: "dashboardsExamples",
      isActive: "active",
      company_is_inactive: false,
    };
  },
  components: {
    SidenavCollapse,
    // SidenavCard,
    // Shop,
    // Office,
    // CreditCard,
    blocker_modal,
    CustomerSupport,
  },
  methods: {
    package_contains,
    can,
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },

    unblock() {
      this.company_is_inactive = false;
    },
    lock_org_if_necessary() {
      const is_active = this.$store.getters.company_is_active;
      if (is_active == 0 || is_active == "0") {
        this.company_is_inactive = true;
        console.log("should be locked");
      } else {
        this.company_is_inactive = false;
      }
    },

    async handleSignOut() {
      const url = "logout";
      const body = {};
      await generalApiRequest(url, "POST", body, 1);

      this.$store.dispatch("updateUser", "");
      this.$store.dispatch("updateToken", "");

      localStorage.removeItem("user");
      localStorage.removeItem("token");

      location.reload();
      location.reload();
    },
  },
  mounted() {
    this.lock_org_if_necessary();
  },
};
</script>
<style scoped>
.sidenav-scroll {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
